module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/account.component.html
// module id = ../../../../../src/app/account/account.component.html
// module chunks = main